<section class="content attendance-type-page">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
        [items]="[('attendanceJustificationTypesCatalog.breadcrumb' | translate)]"
        [active_item]="(isCreateMode
          ? ('attendanceJustificationTypesCatalog.detail.createBreadcrumb' | translate)
          : isEditMode
            ? ('attendanceJustificationTypesCatalog.detail.editBreadcrumb' | translate)
            : ('attendanceJustificationTypesCatalog.detail.breadcrumb' | translate))">
      </app-breadcrumb>
    </div>

    <div class="attendance-type-workspace" [class.attendance-type-workspace--loading]="isLoading">
      @if (isCreateMode || isEditMode) {
        <mat-card class="editor-panel">
          <div class="editor-panel__header">
            <div>
              <span class="eyebrow">{{ 'attendanceJustificationTypesCatalog.breadcrumb' | translate }}</span>
              <h2>{{ detailTitle }}</h2>
              <p>{{ detailDescription }}</p>
            </div>
            <div class="page-actions">
              <button mat-flat-button type="button" class="btn-tone-primary"
                      (click)="save()" [disabled]="isSaving || !canSave">
                <mat-icon>save</mat-icon>
                {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
              </button>
              <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="cancelEdit()" [disabled]="isSaving">
                <mat-icon>arrow_back</mat-icon>
                {{ 'common.cancel' | translate }}
              </button>
            </div>
          </div>

          <div class="editor-sections">
            <section class="editor-section">
              <div class="section-heading section-heading--compact">
                <div>
                  <h3>{{ 'attendanceJustificationTypesCatalog.sections.general' | translate }}</h3>
                  <p>{{ 'attendanceJustificationTypesCatalog.sections.generalDescription' | translate }}</p>
                </div>
                <span class="required-badge">{{ 'common.requiredLabel' | translate }}</span>
              </div>
              <div class="row g-3">
                <div class="col-12 col-lg-6">
                  <mat-form-field subscriptSizing="dynamic" appearance="outline">
                    <mat-label>{{ 'attendanceJustificationTypesCatalog.fields.label' | translate }}</mat-label>
                    <input matInput [(ngModel)]="form.label" [disabled]="isSaving"
                           [placeholder]="'attendanceJustificationTypesCatalog.fields.labelPlaceholder' | translate">
                  </mat-form-field>
                </div>
                <div class="col-12 col-lg-6">
                  <mat-form-field subscriptSizing="dynamic" appearance="outline">
                    <mat-label>{{ 'attendanceJustificationTypesCatalog.fields.code' | translate }}</mat-label>
                    <input matInput [(ngModel)]="form.code" [disabled]="isSaving" data-no-spaces="true"
                           [placeholder]="'attendanceJustificationTypesCatalog.fields.codePlaceholder' | translate">
                    <mat-hint>{{ 'attendanceJustificationTypesCatalog.fields.codeHint' | translate }}</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col-12">
                  <mat-form-field subscriptSizing="dynamic" appearance="outline">
                    <mat-label>{{ 'attendanceJustificationTypesCatalog.fields.description' | translate }}</mat-label>
                    <textarea matInput rows="3" [(ngModel)]="form.description" [disabled]="isSaving"
                              [placeholder]="'attendanceJustificationTypesCatalog.fields.descriptionPlaceholder' | translate"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </section>

            <section class="editor-section">
              <div class="section-heading section-heading--compact">
                <div>
                  <h3>{{ 'attendanceJustificationTypesCatalog.sections.behavior' | translate }}</h3>
                  <p>{{ 'attendanceJustificationTypesCatalog.sections.behaviorDescription' | translate }}</p>
                </div>
              </div>
              <div class="row g-3">
                <div class="col-12 col-lg-6">
                  <mat-form-field subscriptSizing="dynamic" appearance="outline">
                    <mat-label>{{ 'attendanceJustificationTypesCatalog.fields.attendanceEffect' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.attendanceEffect" [disabled]="isSaving">
                      @for (attendanceEffect of attendanceEffectOptions; track attendanceEffect) {
                        <mat-option [value]="attendanceEffect">
                          {{ ('attendanceJustificationTypesCatalog.attendanceEffectOptions.' + attendanceEffect) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-12 col-lg-6">
                  <mat-form-field subscriptSizing="dynamic" appearance="outline">
                    <mat-label>{{ 'attendanceJustificationTypesCatalog.fields.payEffect' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.payEffect" [disabled]="isSaving">
                      @for (payEffect of payEffectOptions; track payEffect) {
                        <mat-option [value]="payEffect">
                          {{ ('attendanceJustificationTypesCatalog.payEffectOptions.' + payEffect) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </section>

            <section class="editor-section">
              <div class="section-heading section-heading--compact">
                <div>
                  <h3>{{ 'attendanceJustificationTypesCatalog.sections.rules' | translate }}</h3>
                  <p>{{ 'attendanceJustificationTypesCatalog.sections.rulesDescription' | translate }}</p>
                </div>
              </div>
              <div class="toggle-grid">
                @for (toggleKey of toggleOptions; track toggleKey) {
                  <div class="toggle-card">
                    <div>
                      <strong>{{ ('attendanceJustificationTypesCatalog.fields.' + toggleKey) | translate }}</strong>
                      <p>{{ ('attendanceJustificationTypesCatalog.fieldsHints.' + toggleKey) | translate }}</p>
                    </div>
                    <mat-slide-toggle [(ngModel)]="form[toggleKey]" [disabled]="isSaving"></mat-slide-toggle>
                  </div>
                }
                @if (isEditMode) {
                  <div class="toggle-card toggle-card--wide">
                    <div>
                      <strong>{{ 'attendanceJustificationTypesCatalog.fields.status' | translate }}</strong>
                      <p>{{ 'attendanceJustificationTypesCatalog.fields.statusHint' | translate }}</p>
                    </div>
                    <mat-slide-toggle [(ngModel)]="form.isActive" [disabled]="isSaving"></mat-slide-toggle>
                  </div>
                }
              </div>
            </section>
          </div>
        </mat-card>
      } @else if (selectedAttendanceJustificationType; as item) {
        <article class="detail-view">
          <section class="surface-card hero-card">
            <div class="hero-card__identity">
              <div class="hero-card__icon" aria-hidden="true"><mat-icon>work_outline</mat-icon></div>
              <div class="hero-card__copy">
                <div class="hero-card__title-line">
                  <h1>{{ item.label }}</h1>
                  <span class="status-pill" [class.status-pill--inactive]="!item.isActive">
                    <span class="status-pill__dot"></span>{{ item.activeLabel }}
                  </span>
                </div>
                <p class="hero-card__code">{{ 'attendanceJustificationTypesCatalog.fields.code' | translate }}: {{ item.code }}</p>
                <p class="hero-card__description">{{ item.description || ('attendanceJustificationTypesCatalog.detail.noDescription' | translate) }}</p>
              </div>
            </div>
            <div class="page-actions">
              <button mat-stroked-button type="button" class="action-button action-button--primary"
                      *appCanAccess="updateAccess" (click)="startEdit()">
                <mat-icon>edit</mat-icon>{{ 'common.edit' | translate }}
              </button>
              <button mat-stroked-button type="button" class="action-button" *appCanAccess="deleteAccess"
                      [matMenuTriggerFor]="moreActionsMenu">
                <mat-icon>more_vert</mat-icon>{{ 'attendanceJustificationTypesCatalog.actions.more' | translate }}
              </button>
              <mat-menu #moreActionsMenu="matMenu" xPosition="before">
                <button mat-menu-item *appCanAccess="deleteAccess" (click)="deleteSelected()">
                  <mat-icon>delete_outline</mat-icon>
                  <span>{{ 'common.delete' | translate }}</span>
                </button>
              </mat-menu>
              <button mat-stroked-button type="button" class="action-button" (click)="goBackToList()">
                <mat-icon>arrow_back</mat-icon>{{ 'common.back' | translate }}
              </button>
            </div>
          </section>

          <section class="surface-card content-card">
            <div class="section-heading">
              <div class="section-heading__icon"><mat-icon>assignment_turned_in</mat-icon></div>
              <div>
                <h2>{{ 'attendanceJustificationTypesCatalog.sections.effects' | translate }}</h2>
                <p>{{ 'attendanceJustificationTypesCatalog.sections.effectsDescription' | translate }}</p>
              </div>
            </div>
            <div class="effects-grid">
              <div class="effect-card effect-card--attendance">
                <div class="effect-card__icon"><mat-icon>calendar_month</mat-icon></div>
                <div>
                  <span>{{ 'attendanceJustificationTypesCatalog.detail.inAttendance' | translate }}</span>
                  <strong>{{ item.attendanceEffectLabel }}</strong>
                  <p>{{ ('attendanceJustificationTypesCatalog.effectDescriptions.' + item.attendanceEffect) | translate }}</p>
                </div>
              </div>
              <div class="effect-card effect-card--pay">
                <div class="effect-card__icon"><mat-icon>paid</mat-icon></div>
                <div>
                  <span>{{ 'attendanceJustificationTypesCatalog.detail.inPay' | translate }}</span>
                  <strong>{{ item.payEffectLabel }}</strong>
                  <p>{{ ('attendanceJustificationTypesCatalog.payDescriptions.' + item.payEffect) | translate }}</p>
                </div>
              </div>
            </div>
          </section>

          <div class="detail-columns">
            <section class="surface-card content-card">
              <div class="section-heading">
                <div class="section-heading__icon"><mat-icon>assignment</mat-icon></div>
                <div>
                  <h2>{{ 'attendanceJustificationTypesCatalog.sections.requirements' | translate }}</h2>
                  <p>{{ 'attendanceJustificationTypesCatalog.sections.requirementsDescription' | translate }}</p>
                </div>
              </div>
              <div class="detail-list">
                <div class="detail-list__row">
                  <mat-icon>verified_user</mat-icon>
                  <strong>{{ 'attendanceJustificationTypesCatalog.detail.approval' | translate }}</strong>
                  <span class="value-pill" [class.value-pill--required]="item.requiresApproval">
                    {{ (item.requiresApproval ? 'attendanceJustificationTypesCatalog.detail.required' : 'attendanceJustificationTypesCatalog.detail.optional') | translate }}
                  </span>
                  <p>{{ 'attendanceJustificationTypesCatalog.fieldsHints.requiresApproval' | translate }}</p>
                </div>
                <div class="detail-list__row">
                  <mat-icon>chat</mat-icon>
                  <strong>{{ 'attendanceJustificationTypesCatalog.detail.comment' | translate }}</strong>
                  <span class="value-pill" [class.value-pill--required]="item.requireComment">
                    {{ (item.requireComment ? 'attendanceJustificationTypesCatalog.detail.required' : 'attendanceJustificationTypesCatalog.detail.optional') | translate }}
                  </span>
                  <p>{{ 'attendanceJustificationTypesCatalog.fieldsHints.requireComment' | translate }}</p>
                </div>
                <div class="detail-list__row">
                  <mat-icon>attach_file</mat-icon>
                  <strong>{{ 'attendanceJustificationTypesCatalog.detail.attachment' | translate }}</strong>
                  <span class="value-pill" [class.value-pill--required]="item.requireAttachment">
                    {{ (item.requireAttachment ? 'attendanceJustificationTypesCatalog.detail.required' : 'attendanceJustificationTypesCatalog.detail.optional') | translate }}
                  </span>
                  <p>{{ 'attendanceJustificationTypesCatalog.fieldsHints.requireAttachment' | translate }}</p>
                </div>
              </div>
            </section>

            <section class="surface-card content-card">
              <div class="section-heading">
                <div class="section-heading__icon"><mat-icon>groups</mat-icon></div>
                <div>
                  <h2>{{ 'attendanceJustificationTypesCatalog.sections.permissions' | translate }}</h2>
                  <p>{{ 'attendanceJustificationTypesCatalog.sections.permissionsDescription' | translate }}</p>
                </div>
              </div>
              <div class="detail-list">
                <div class="detail-list__row detail-list__row--permission">
                  <mat-icon>person</mat-icon>
                  <strong>{{ 'attendanceJustificationTypesCatalog.detail.employee' | translate }}</strong>
                  <span class="permission-pill" [class.permission-pill--denied]="!item.allowEmployeeCreate">
                    <mat-icon>{{ item.allowEmployeeCreate ? 'check' : 'close' }}</mat-icon>
                    {{ (item.allowEmployeeCreate ? 'attendanceJustificationTypesCatalog.detail.allowed' : 'attendanceJustificationTypesCatalog.detail.notAllowed') | translate }}
                  </span>
                  <p>{{ 'attendanceJustificationTypesCatalog.detail.employeePermissionDescription' | translate }}</p>
                </div>
                <div class="detail-list__row detail-list__row--permission">
                  <mat-icon>manage_accounts</mat-icon>
                  <strong>{{ 'attendanceJustificationTypesCatalog.detail.administration' | translate }}</strong>
                  <span class="permission-pill" [class.permission-pill--denied]="!item.allowAdminCreate">
                    <mat-icon>{{ item.allowAdminCreate ? 'check' : 'close' }}</mat-icon>
                    {{ (item.allowAdminCreate ? 'attendanceJustificationTypesCatalog.detail.allowed' : 'attendanceJustificationTypesCatalog.detail.notAllowed') | translate }}
                  </span>
                  <p>{{ 'attendanceJustificationTypesCatalog.detail.adminPermissionDescription' | translate }}</p>
                </div>
              </div>
            </section>
          </div>

          <section class="surface-card content-card general-card">
            <div class="section-heading">
              <div class="section-heading__icon section-heading__icon--neutral"><mat-icon>info</mat-icon></div>
              <div>
                <h2>{{ 'attendanceJustificationTypesCatalog.sections.general' | translate }}</h2>
                <p>{{ 'attendanceJustificationTypesCatalog.detail.generalDescription' | translate }}</p>
              </div>
            </div>
            <div class="general-grid">
              <dl>
                <div><dt>{{ 'attendanceJustificationTypesCatalog.fields.code' | translate }}</dt><dd>{{ item.code }}</dd></div>
                <div><dt>{{ 'attendanceJustificationTypesCatalog.fields.label' | translate }}</dt><dd>{{ item.label }}</dd></div>
              </dl>
              <dl>
                <div><dt>{{ 'attendanceJustificationTypesCatalog.fields.description' | translate }}</dt><dd>{{ item.description || '-' }}</dd></div>
                <div><dt>{{ 'attendanceJustificationTypesCatalog.fields.status' | translate }}</dt><dd><span class="inline-status-dot" [class.inline-status-dot--inactive]="!item.isActive"></span>{{ item.activeLabel }}</dd></div>
              </dl>
              <dl>
                <div><dt>{{ 'attendanceJustificationTypesCatalog.fields.attendanceEffect' | translate }}</dt><dd>{{ item.attendanceEffectLabel }}</dd></div>
                <div><dt>{{ 'attendanceJustificationTypesCatalog.fields.payEffect' | translate }}</dt><dd>{{ item.payEffectLabel }}</dd></div>
              </dl>
            </div>
          </section>
        </article>
      } @else if (!isLoading) {
        <div class="surface-card empty-state">
          <mat-icon>assignment_turned_in</mat-icon>
          <h2>{{ 'attendanceJustificationTypesCatalog.emptyEditorTitle' | translate }}</h2>
          <p>{{ 'attendanceJustificationTypesCatalog.emptyEditorDescription' | translate }}</p>
        </div>
      }

      @if (isLoading) {
        <app-loading-state class="attendance-type-loading"
                           [message]="'attendanceJustificationTypesCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
